import type zh from '../zh/tasks';

/** Tasks page, English. Typed against the zh file so a missing key fails tsc. */
const tasks: typeof zh = {
  page: {
    title: 'Tasks',
    scheduledTab: 'Scheduled Tasks',
    historyTab: 'Execution History',
  },
  dateLocale: 'en-US',
  scheduled: {
    title: 'Scheduled Tasks',
    description: 'Cron task management · view schedules, execution history and results',
    loading: 'Loading tasks...',
    loadFailed: 'Failed to load tasks',
    errorTitle: 'Error loading tasks',
    emptyTitle: 'No scheduled tasks',
    emptyBody: 'No tasks have been created yet.',
    filterEmptyTitle: 'No tasks',
    filterEmptyBody: 'No scheduled tasks found.',
    noMatchTitle: 'No matches',
    noMatchBody: 'No tasks match the filter.',
    filterPlaceholder: 'Find tasks',
    matches: '{{n}} matches',
    hint: 'Use the chat on the right to create and manage scheduled tasks in plain language. Tell Rocky what to do, when, and how often. For example:',
    hintIcon: 'Info',
    example1: '"Every Monday at 9 am, send me news about my customers and how it affects my pipeline"',
    example2: '"Every Tuesday at 10 am, email me the revenue and pipeline progress of my top 10 customers"',
    example3: '"Every morning, remind me on Slack which pipeline items need a follow-up"',
    example4: '"Stop sending me the daily Sales Daily Brief"',
  },
  columns: {
    name: 'Task name',
    payload: 'Payload',
    schedule: 'Schedule',
    nextRun: 'Next run',
    lastRun: 'Last run',
    status: 'Status',
    taskId: 'Task ID',
  },
  status: {
    scheduled: 'Active',
    completed: 'Completed',
    invokeFailed: 'Invocation failed',
  },
  preferences: {
    title: 'Preferences',
    confirm: 'Confirm',
    cancel: 'Cancel',
    pageSize: 'Page size',
    pageSizeOption: '{{n}} items',
    visibleColumns: 'Visible columns',
    taskProperties: 'Task properties',
    wrapLines: 'Wrap lines',
    wrapLinesDescription: 'Wrap long lines in table cells',
    stripedRows: 'Striped rows',
    stripedRowsDescription: 'Alternate row shading',
  },
  history: {
    title: 'Execution History',
    loadFailed: 'Failed to load execution history',
    last7: 'Last 7 Days',
    last30: 'Last 30 Days',
    last90: 'Last 90 Days',
    statusAll: 'Status: All',
    statusSuccess: 'Success',
    statusFailed: 'Failed',
    statusRunning: 'Running',
    contentTypeAll: 'Content Type',
    emptyTitle: 'No execution records',
    emptyBody: 'No executions found for the selected filters.',
    itemsOne: '{{n}} Item',
    itemsMany: '{{n}} Items',
    errorsDetected: '({{n}} Error Detected)',
    taskId: 'Task ID: {{id}}',
    time: 'Time: {{time}}',
    contentType: 'Content Type: {{type}}',
    timeUsed: 'Time Used: {{duration}}',
    itemSuccess: 'Success',
    itemError: 'Error',
    itemRunning: 'Running',
  },
};

export default tasks;
